<template>
  <div style="background-color: rgb(242,246,249);padding: 0.5rem">
    <div   class="top_outside_box">
      <el-row   class="el_row_top">
        <el-col :xs="24" :sm="4" :md="4" :lg="3" :xl="3">
          <div class="grid-content  image_box">
            <div class="image_background_box">
              <img :src="logoImg" style="width: 80%;height: 6rem;">
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="9" :md="8" :lg="8" :xl="9">
          <div class="grid-content ">
            <div class="top_word_box">
              <div class="app_name_box">
                <span style="font-size: 1.5rem;font-weight: 600;padding: 0 0.5rem">{{ appName }}</span>
                <span class="header_small_box">官网</span>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="11" :md="12" :lg="13" :xl="12">
        </el-col>
      </el-row>
    </div>
    <div class="middle_outside_box">
      <div class="image_box_big image_box_center">
        <img v-for="(item,index) in appImgArr" :key="index" :src="item.photo" class="app_image_style"/>
      </div>
      <p style="font-size: 1.25rem;font-weight: 600;padding: 0.5rem 0.5rem">应用信息</p>
      <p style="font-size: 0.85rem;padding: 0  0.5rem 1rem" v-if="oneWord">{{ oneWord }}</p>
      <p style="font-size: 0.85rem;padding: 0 0.5rem" v-else>找兼职就用{{ appName }}软件！</p>
      <p style="font-size: 0.85rem;padding: 0 0.5rem 1rem" v-if="towWord">{{ towWord }}</p>
      <p style="font-size: 0.85rem;padding: 0.5rem 0.5rem" v-else>
        {{ appName }}是一款能够让你轻松兼职的网络兼职手机应用。满足在校大学生，居家宝妈和上班族利用空闲时间兼职的需求，众多名气直聘的兼职岗位，并提供满意可靠服务的互联网兼职的垂直平台。以众多优质兼职资源为依托，为兼职者提供人性化，个性化，专业化的兼职信息服务，让兼职者和优秀企业都能及时解决个人所需达成合作，让每一次兼职变得更便捷，更愉悦！</p>
    </div>
    <div class="bottom_outside_box">
      <span class="bottom_span_one">版权所有：{{ company }}</span>
      <span class="bottom_span_tow">备案号：<a href="https://beian.miit.gov.cn" target="_blank" style="font-size: 0.85rem;color: #666">{{ icpNum }}</a></span>
    </div>
  </div>

</template>

<script>
export default {
  name: "smallFish",
  data(){
    return{
      logoImg:require('../assets/smallFishImg/logo.png'),
      appImgArr:[
        {id:1,photo:require('../assets/smallFishImg/one.png')},
        {id:2,photo:require('../assets/smallFishImg/tow.png')},
        {id:3,photo:require('../assets/smallFishImg/three.png')},
        {id:4,photo:require('../assets/smallFishImg/four.png')},
      ],
      appName:'小鱼一键复制',
      company:'厦门热摆摆网络科技有限公司',
      icpNum:'闽ICP备18019105号-1',
      oneWord:'小鱼一键复制包含单品复制、批量复制、整店复制等功能，能够帮助商家快速实现商品信息跨平台复制，一键上传到店铺。',
      towWord:'商家通过服务市场购买该服务后，无需下载、安装、注册，直接授权登录即可跳转到服务主页。通过一键搬家功能，输入商品链接或者店铺链接，即可一键抓取商品信息，进行必要的参数修改后，一键复制到店铺。通过商品复制记录可查看记录数据。'
    }
  },

}
</script>

<style scoped>
.top_outside_box{
  width: 72%;
  height: 10.5rem;
  margin: 1rem auto;
  background-color: white;
}

.grid-content {
  min-height: 7.5rem;
}
.image_box{
  display: flex;
  align-items: center;
  justify-content: end;
}
.image_background_box{
  width: 92%;
  height: 7.5rem;
  background-color: rgb(244,244,244);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.63rem;
}
.top_word_box{
  width: 100%;
}
.app_name_box{
  width: 100%;
  height: 2.5rem;
}
.header_small_box{
  width: 1.6rem;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.8rem;
  border: 1px solid #267DEB;
  color: #267DEB;
  padding: 0 4px;
  margin-left: 0.8rem;
}
.middle_start_box{
  display: flex;
  align-items: center;
}
.image_start_span{
  font-size: 1.3rem;
  margin-left: 1rem;
}
.bottom_word_box{
  width: 17rem;
  display: flex;
  justify-content: space-between;
}
.word_bottom_style{
  color: #999;
  font-size: 0.85rem;
}
.right_button_box{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
}
.header_btn_class{
  width: 9rem;
  height: 3rem;
  font-size: 1.25rem;
  color: white;
  background-color: var(--downBtn);
  margin: 0.5rem 0;
  text-align: center;
  line-height: 3rem;
  text-decoration: none;
}
.el_row_top{
  padding: 1.5rem;
}
.middle_outside_box{
  width: 72%;
  min-height: 20rem;
  background-color: white;
  margin: 0 auto;
}
.app_image_style{
  width: 23%;
  height: 85%;
  padding: 0 0.35rem;
}
.bottom_outside_box{
  width: 100%;
  height: 5%;
  padding: 2rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bottom_span_one{
  font-size: 0.85rem;
  color: #666;
}
.bottom_span_tow{
  font-size: 0.85rem;
  padding-left: 6rem;
  color: #666;
}
.middle_outside_box{
  padding: 0.8rem 0;
}
@media (min-width: 1200px) {
  .image_background_box{
    width: 73%;
  }
  .app_image_style{
    width: 47%;
    height: 85%;
    padding: 0.5rem 0.35rem;
  }
  .image_box_big{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
}
@media  (min-width: 979px) and (max-width: 1200px)  {
  .top_outside_box{
    width: 100%;
  }
  .middle_outside_box{
    width: 100%;
  }
}

/* 平板电脑和小屏电脑之间的分辨率 */
@media (min-width: 768px) and (max-width: 979px) {
  .top_outside_box{
    width: 100%;
  }
  .middle_outside_box{
    width: 100%;
  }
  .app_image_style{
    height: 80%;
  }
}

/* 横向放置的手机和竖向放置的平板之间的分辨率 */
@media (max-width: 767px) {
  .top_outside_box{
    width: 100%;
    height: auto;
  }
  .image_box{
    height: 8rem;
    justify-content: center;
  }
  .image_background_box{
    width: 17.35%;
  }
  .el_row_top{
    padding: 0;
  }
  .app_name_box{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .right_button_box{
    align-items: center;
  }
  .header_btn_class:nth-last-child(1){
    display: none;
  }
  .bottom_word_box{
    width: 100%;
    justify-content: space-between !important;
  }
  .image_background_box{
    width: 7rem;
    height: 7rem;
  }
  .middle_outside_box{
    width: 100%;
    overflow: hidden;
    overflow-x: auto;
  }
  .app_image_style{
    width: 10rem;
    height: 80%;
  }
  .image_box_center{
    display: flex;
    overflow-x: auto;

  }
}

/* 横向放置的手机及分辨率更小的设备 */
@media (max-width: 480px) {
  .top_outside_box{
    width: 100%;
  }
  .image_background_box{
    width: 7rem;
    height: 7rem;
  }
  .middle_outside_box{
    width: 100%;
  }
  .app_image_style{
    height: 80%;
  }
  .bottom_outside_box{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
  .bottom_span_tow{
    padding-left: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/smallFish.vue